import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: '#fff',
      boxShadow: theme.shadows.sm,
      borderRadius: theme.radius.lg,
      padding: 16,
    },
    content: {
      marginRight: -10,
    },
    authorBox: {
      textAlign: 'right',
      '& > div': {
        display: 'inline-block',
        verticalAlign: 'middle',
      },
    },
    author: {
      color: '#8c8c8c',
    },
    divider: {
      display: 'inline-block',
      width: 12,
      height: 1,
      backgroundColor: '#8c8c8c',
      marginRight: 8,
    },
  }
})
